<app-overridable-section
    title="Currency Configuration"
    [overridden]="overridden()"
    (overriddenChange)="onToggle($event)"
    [dirty]="dirty()"
    (reset)="resetAll()"
    (importFrom)="openImportDialog()"
>
    <app-category-currency-form [(value)]="draft" [disabled]="!overridden()" />
</app-overridable-section>

<!-- Currency fill-from dialog -->
<p-dialog
    header="Fill Currency from Another Website"
    [visible]="importDialogVisible()"
    (visibleChange)="importDialogVisible.set($event)"
    [style]="{ width: '28rem' }"
    [breakpoints]="{ '960px': '90vw' }"
    [modal]="true"
>
    <div class="flex flex-col gap-4">
        <p class="m-0 text-muted-color text-sm">
            Select a source website to copy its effective Currency configuration into the current form. This sets an explicit override. No changes will be saved until you click <strong>Save all</strong>.
        </p>
        <div>
            <label class="block font-medium mb-1">Source Website</label>
            <p-select
                class="w-full"
                [ngModel]="importSourceRealmId()"
                (ngModelChange)="importSourceRealmId.set($event)"
                [options]="importableRealms()"
                optionLabel="Domain"
                optionValue="RealmId"
                placeholder="Select website…"
                [loading]="realmService.loading()"
                appendTo="body"
            />
        </div>
    </div>
    <ng-template #footer>
        <p-button
            label="Cancel"
            text
            severity="secondary"
            (click)="importDialogVisible.set(false)"
            [disabled]="importLoading()"
        />
        <p-button
            label="Fill Fields"
            icon="pi pi-check"
            [disabled]="!importSourceRealmId()"
            [loading]="importLoading()"
            (click)="applyImport()"
        />
    </ng-template>
</p-dialog>
